import _get from "lodash/get";
import { rem, tint, shade } from 'polished';
import { css } from 'styled-components';
import baseTheme from './baseTheme';

var baseScrollbarStyles = function baseScrollbarStyles(_ref) {
  var theme = _ref.theme,
      themeMode = _ref.themeMode,
      size = _ref.size,
      color = _ref.color,
      borderRadius = _ref.borderRadius,
      marginV = _ref.marginV;
  var trackColorFunction = themeMode === 'darkMode' ? shade : tint;
  var thumbColorFunction = themeMode === 'darkMode' ? tint : shade;
  return css(["&::-webkit-scrollbar{height:", ";width:", ";}&::-webkit-scrollbar-track{background-color:", ";border-radius:", ";margin:", " 0;}&::-webkit-scrollbar-thumb{background-color:", ";border-radius:", ";}"], rem(size || _get(theme, 'base.scrollbar.size', baseTheme.base.scrollbar.size)), rem(size || _get(theme, 'base.scrollbar.size', baseTheme.base.scrollbar.size)), trackColorFunction(0.15, color || _get(theme, 'base.scrollbar.color', baseTheme.base.scrollbar.color)), rem(borderRadius || _get(theme, 'base.scrollbar.borderRadius.track', baseTheme.base.scrollbar.borderRadius.track)), rem(marginV || _get(theme, 'base.scrollbar.marginV', baseTheme.base.scrollbar.marginV)), thumbColorFunction(0.15, color || _get(theme, 'base.scrollbar.color', baseTheme.base.scrollbar.color)), rem(borderRadius || _get(theme, 'base.scrollbar.borderRadius.thumb', baseTheme.base.scrollbar.borderRadius.thumb)));
};

export default baseScrollbarStyles;